// export const host: string = (() => {
//   const environmentMappings: { [key: string]: string } = {
//     test: 'https://test-portal.signalplus.cloud',
//     production: 'https://test-portal.signalplus.cloud',
//     development: 'https://test-portal.signalplus.cloud',
//   };
//   const environment = import.meta.env.DEV ? 'development' : import.meta.env.PROD ? 'production' : 'test';
//   console.log('environment：', environment);
//   return environmentMappings[environment];
// })();
export const host: string = import.meta.env.VITE_APP_BASE_API;

//user
export const adminLoginUrl = `${host}/tech/admin/login`;
export const resetPasswordUrl = `${host}/tech/admin/modify-password`;
export const adminUserInfoUrl = `${host}/tech/admin/info`;
export const exchangeListUrl = `${host}/tech/dictionary/exchange`;
// 2fa
export const sendCodeUrl = `${host}/tech/admin/send-code`;
export const verifyCodeUrl = `${host}/tech/admin/verify-code`;
export const generateMfaSecretUrl = `${host}/tech/admin/generate-mfa-secret`;
export const saveMfaSecretUrl = `${host}/tech/admin/save-mfa-secret`;
export const unbindUrl = `${host}/tech/admin/unbind-mfa`;

//tenant
export const tenantListUrl = `${host}/tech/tenant/list`;
export const addTenantUrl = `${host}/tech/tenant/add`;
export const updateTenantUrl = `${host}/tech/tenant/update`;
export const deleteTenantUrl = `${host}/tech/tenant/delete`;

//console version
export const consoleVersionListUrl = `${host}/tech/console-version/list`;
export const addConsoleVersionUrl = `${host}/tech/console-version/add`;
export const updateConsoleVersionUrl = `${host}/tech/console-version/update`;
export const deleteConsoleVersionUrl = `${host}/tech/console-version/delete`;

//bot version
export const botVersionListUrl = `${host}/tech/bot-version/list`;
export const addBotVersionUrl = `${host}/tech/bot-version/add`;
export const updateBotVersionUrl = `${host}/tech/bot-version/update`;
export const deleteBotVersionUrl = `${host}/tech/bot-version/delete`;
export const downloadBotVersionUrl = `${host}/tech/bot-version/download`;

export const botStatusUrl = `${host}/tech/bot-instance/state`;

//SupportCase
export const supportCaseListUrl = `${host}/tech/support-case/list`;
export const supportCaseOnboardDetailUrl = `${host}/tech/support-case/onboard/detail`;
export const supportCaseOfflineDetailUrl = `${host}/tech/support-case/offline/detail`;
export const addSupportCaseUrl = `${host}/tech/support-case/add`;
export const updateSupportCaseUrl = `${host}/tech/support-case/onboard/create-bot-instance`;
export const deleteSupportCaseUrl = `${host}/tech/support-case/delete`;
export const createBotInstanceUrl = `${host}/tech/support-case/onboard/create-bot-instance`;


//consoleInstance
export const consoleInstanceListUrl = `${host}/tech/console-instance/list`;
export const addConsoleInstanceUrl = `${host}/tech/console-instance/add`;
export const updateConsoleInstanceUrl = `${host}/tech/console-instance/update`;
export const deleteConsoleInstanceUrl = `${host}/tech/console-instance/delete`;

//botInstance
export const botInstanceListUrl = `${host}/tech/bot-instance/list`;
export const addBotInstanceUrl = `${host}/tech/bot-instance/add`;
export const submitBotInstanceUrl = `${host}/tech/bot-instance/submit`;
export const deleteBotInstanceUrl = `${host}/tech/bot-instance/delete`;
export const launchBotInstanceUrl = `${host}/tech/bot-instance/launch`;



//parameter schema
export const parameterSchemaListUrl = `${host}/tech/parameter-schema/list`;
export const parameterSchemaDetailUrl = `${host}/tech/parameter-schema/detail`;
export const addParameterSchemaUrl = `${host}/tech/parameter-schema/add`;
export const updateParameterSchemaUrl = `${host}/tech/parameter-schema/update`;
export const duplicateParameterSchemaUrl = `${host}/tech/parameter-schema/duplicate`;
export const deleteParameterSchemaUrl = `${host}/tech/parameter-schema/delete`;
export const publishParameterSchemaUrl = `${host}/tech/parameter-schema/publish`;

//parameter group
export const parameterGroupListUrl = `${host}/tech/parameter-template/list`;
export const addParameterTemplateUrl = `${host}/tech/parameter-template/add`;
export const updateParameterTemplateUrl = `${host}/tech/parameter-template/update`;
export const deleteParameterTemplateUrl = `${host}/tech/parameter-template/delete`;

// parameter
// export const parameterListUrl = `${host}/tech/parameter/list`;
export const addParameterUrl = `${host}/tech/parameter/add`;
export const addChildParameterUrl = `${host}/tech/parameter/add-child`;
export const updateParameterUrl = `${host}/tech/parameter/update`;
export const deleteParameterUrl = `${host}/tech/parameter/delete`;
export const moveParameterUrl = `${host}/tech/parameter/move`;
export const sortParameterUrl = `${host}/tech/parameter/reorder`;



//parameter currency default value
export const parameterCurrencyDefaultValueListUrl = `${host}/tech/parameter-currency-default-value/list`;
export const addParameterCurrencyDefaultValueUrl = `${host}/tech/parameter-currency-default-value/add`;
export const updateParameterCurrencyDefaultValueUrl = `${host}/tech/parameter-currency-default-value/update`;
export const deleteParameterCurrencyDefaultValueUrl = `${host}/tech/parameter-currency-default-value/delete`;

//parameter bot default value
export const parameterBotDefaultValueListUrl = `${host}/tech/parameter-bot-default-value/list`;
export const addParameterBotDefaultValueUrl = `${host}/tech/parameter-bot-default-value/add`;
export const updateParameterBotDefaultValueUrl = `${host}/tech/parameter-bot-default-value/update`;
export const deleteParameterBotDefaultValueUrl = `${host}/tech/parameter-bot-default-value/delete`;

// parameter rules
export const parameterRulesListUrl = `${host}/tech/parameter-template/rule`;
export const parameterRulesCheckUrl = `${host}/tech/parameter-template/rule/check`;
export const parameterRulesSaveUrl = `${host}/tech/parameter-template/rule/save`;

//bot config
export const botConfigListUrl = `${host}/tech/bot-config/list`;
export const addBotConfigUrl = `${host}/tech/bot-config/add`;
export const updateBotConfigUrl = `${host}/tech/bot-config/update`;
export const deleteBotConfigUrl = `${host}/tech/bot-config/delete`;

//expiryDay & instruments
export const expiryDaysUrl = `${host}/tech/tenor/expiryDays`;
export const instrumentsUrl = `${host}/tech/tenor/instruments`;
export const coinsUrl = `${host}/tech/dictionary/currency`;
export const botsUrl = `${host}/tech/parameter-schema/bot-code-list`;

